import { type Action, FilterActionTypes, action } from "easy-peasy";

import DEFAULT_HAS_LAST_TABLE from "./default";
import { type LogEffect, createLogEffect } from "../../utils/store";

const logEffect = (property: keyof FilterActionTypes<HasLastTableModel>) =>
  createLogEffect<HasLastTableModel>("HAS_LAST_TABLE", property, false);

export type HasLastTableModel = {
  value: boolean;
  valueOnChange: LogEffect<HasLastTableModel>;
  set: Action<HasLastTableModel, boolean>;
};

const hasLastTableModel: HasLastTableModel = {
  value: DEFAULT_HAS_LAST_TABLE,
  valueOnChange: logEffect("value"),
  set: action((state, payload) => {
    state.value = payload;
  }),
};

export default hasLastTableModel;
